import { useMemo } from 'react';

import { buildAwsRequester } from './utils';

export const ticketsClient = buildAwsRequester('tickets');

export const useTicketsClient = () => useMemo(() => ticketsClient, []);

export const accountsClient = buildAwsRequester('account');

export const useAccountsClient = () => useMemo(() => accountsClient, []);
